<template>
  <div class="module-options">
    <div class="module-options__inner">
      <div class="module-options__item module-options__item--theme">
        <fieldset
          class="module-options__theme-fieldset"
          role="radiogroup"
        >
          <legend class="module-options__legend">
            {{ $t('Theme') }}
          </legend>
          <div class="module-options__theme-variations">
            <ButtonThemeSelect
              :canvas-name="canvasName"
              :module-data="moduleData"
            />
          </div>
        </fieldset>
      </div>
    </div>
    <ShapeBorderOptions
      :canvas-name="canvasName"
      :module-data="moduleData"
    />
  </div>
</template>

<script>
import ShapeBorderOptions from '@/components/modules/ShapeBorderOptions.vue';
import ButtonThemeSelect from '@/components/ButtonThemeSelect.vue';

export default {
  name: 'AdvancedButtonModuleOptions',
  components: {
    ButtonThemeSelect,
    ShapeBorderOptions,
  },
  props: {
    canvasName: {
      type: String,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
    moduleData: {
      type: Object,
      required: true,
    },
  },
};
</script>
